import { render } from "./hisDetail.vue?vue&type=template&id=1caa598e"
import script from "./hisDetail.vue?vue&type=script&lang=js"
export * from "./hisDetail.vue?vue&type=script&lang=js"

import "./hisDetail.vue?vue&type=style&index=0&id=1caa598e&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__